import { PublicSponsorshipVoucherApi } from '@blank/api'
import { apiClient } from 'modules/common/http/apiClient'

interface Props {
  voucherCode: string
}

export const fetchPublicSponsorshipVoucher = async ({ voucherCode }: Props) => {
  const apiUrl = `/v1/users/sponsorship/voucher/${voucherCode}`

  const { data } = await apiClient.get<PublicSponsorshipVoucherApi>(apiUrl, {
    headers: {
      'Content-Type': 'application/json',
    },
  })

  return data
}
